import { styled } from 'styled-components';

export const LabelText = styled.span`
  font-weight: bold;
  color: ${p => p.theme.colors.textLight};
`;
